/* RESPONSIBLE TEAM: team-knowledge-foundations */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend({
  attrs: {
    parent: { key: 'parent_id' },
  },
});
